export default "__VITE_ASSET__9c9b0a21__"